import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationService } from './Services/navigation.service';
import { SpinnerService } from './Services/spinner.service';
import { NavigationEnd, Router } from '@angular/router';
import { LoginService } from 'src/app/Services/login.service';
import { AppConfigService } from './Services/app-config.service';
import { EmployeeData, UserData } from './Models/employee-and-user-data';
import { Subscription } from 'rxjs';
import { AuthTokenService } from './Services/auth-token/auth-token.service';
import { AzureAppInsightsService } from './Services/azure-app-insights/azure-app-insights.service';
import { readStoredClientIp } from './utils/client-ip-storage';
import { isIosTouchScrollDevice } from './utils/ios-touch-scroll';
import { isAxAppWebView } from './utils/is-ax-app-webview';

declare const gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
  RecordAccessData: any;
  userdata?: UserData;
  employeeData?: EmployeeData;
  nextroute: string = '';
  usertype: string = '';
  login?: string = '';

  private routerSub?: Subscription;
  private recordAccessSub?: Subscription;

  constructor(
    private authTokenSvc : AuthTokenService,
    private appInsightsService: AzureAppInsightsService,
    public navigation: NavigationService,
    public spinnerService: SpinnerService,
    public router: Router,
    private loginservice: LoginService,
    private appConfigService: AppConfigService
  ) {
    this.navigation.startSaveHistory();
    this.routerSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'G-Z8SHLK5LCC', { page_path: event.urlAfterRedirects });
        this.nextroute = event.urlAfterRedirects.split('?')[0].replace(/^\//, '');
        this.syncAxAppScrollMode();
        if (this.nextroute != '' && this.appConfigService.DetailedLogging)
          this.recordNavigationAccess();
      }
    });
  }

  ngOnInit() {
    if (isIosTouchScrollDevice()) {
      document.body.classList.add('ios-touch-scroll');
    }
    this.syncAxAppScrollMode();
    setTimeout(() => this.syncAxAppScrollMode(), 500);
    this.authTokenSvc.RefreshAuthToken();
  }

  private syncAxAppScrollMode(): void {
    if (isAxAppWebView()) {
      if (!isIosTouchScrollDevice()) {
        document.documentElement.classList.add('ax-app-android');
      }

      // Match mobile Safari: document scroll in WKWebView (fixed inner scroll breaks on iOS).
      document.body.classList.add('ios-touch-scroll');
      return;
    }

    if (
      isIosTouchScrollDevice() &&
      !document.body.classList.contains('ios-touch-scroll')
    ) {
      document.body.classList.add('ios-touch-scroll');
    }
  }



  ngOnDestroy() {
    this.routerSub?.unsubscribe();
    this.recordAccessSub?.unsubscribe();
  }

  private recordNavigationAccess(): void {
    const ipAddress = readStoredClientIp();
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    this.employeeData = JSON.parse(localStorage.getItem('eeinfo') || '{}');
    if (this.employeeData?.EmployeeNo != undefined) {
      this.usertype = 'Employee';
      this.login = this.employeeData?.EmployeeNo;
    } else {
      this.usertype = 'Guest';
      this.login = this.userdata?.rebcode;
    }
    if (
      this.login != '' &&
      this.login != undefined &&
      this.nextroute != 'login' &&
      this.nextroute != 'adminlogin'
    ) {
      this.recordAccessSub?.unsubscribe();

      // IF WE DON'T HAVE THE IP ADDRESS THEN WE WANT TO EXIT THIS FUNCTION EARLY
      // WE DON'T WANT TO WAIT FOR THIS API REQUEST TO FAIL...
      if (ipAddress == undefined || ipAddress == null || ipAddress == '') {
        console.error("Unable to extract end users ip address.");
        return;
      }

      this.recordAccessSub = this.loginservice
        .RecordAccess(this.login, true, ipAddress, this.usertype, this.nextroute)
        .subscribe((recordAccessdata) => this.setRecordAccess(recordAccessdata));
    }
  }
  setRecordAccess(resdata: any) {
    this.RecordAccessData = resdata;
    if (this.RecordAccessData.ResRecordAccess.Result.Status == 'A') {
    }
  }


}

